export var RotationReason;
(function (RotationReason) {
    RotationReason["SECURITY_BEST_PRACTICE"] = "SECURITY_BEST_PRACTICE";
    RotationReason["SUSPECTED_COMPROMISE"] = "SUSPECTED_COMPROMISE";
    RotationReason["USER_REQUEST"] = "USER_REQUEST";
    RotationReason["POLICY_REQUIREMENT"] = "POLICY_REQUIREMENT";
})(RotationReason || (RotationReason = {}));
//# sourceMappingURL=document-password.types.js.map